
export class PaddingModel {

    constructor(
        public paddingAll: number = 0,
        public paddingOption: boolean = false,
        public topPadding: number = 0,
        public leftPadding: number = 0,
        public bottomPadding: number = 0,
        public rightPadding: number = 0
    ) { }

    public equals(other: PaddingModel): boolean {
        if (this.paddingAll !== other.paddingAll){
            return false;
        }

        if (this.paddingOption !== other.paddingOption){
            return false;
        }

        if (this.topPadding !== other.topPadding){
            return false;
        }

        if (this.leftPadding !== other.leftPadding){
            return false;
        }

        if (this.bottomPadding !== other.bottomPadding){
            return false;
        }

        if (this.rightPadding !== other.rightPadding){
            return false;
        }

        return true;
    }
}
